module.exports = __webpack_public_path__ + "static/media/school-dashboard-manual.646b117b.zip";